<mat-card>{{'settings' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <mat-label>{{'appColor' | translate}}</mat-label>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <input matInput [ngxMatColorPicker]="picker" [(ngModel)]="hexCode" [disabled]="disabled">
        <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
        <ngx-mat-color-picker #picker [touchUi]="touchUi"></ngx-mat-color-picker>
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="save()">
        <mat-icon>save</mat-icon>
        {{'submit' | translate}}
      </button>
    </mat-grid-tile>



  </mat-grid-list>

  <br />
  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <mat-label>{{'cardCountSendEmail' | translate}}</mat-label>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field>
        <input matInput [(ngModel)]="countCards" required #cardCo="ngModel">
        <mat-error *ngIf="cardCo.invalid">{{'requiredField' | translate}}</mat-error>
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="saveCardCountNotif()">
        <mat-icon>save</mat-icon>
        {{'submit' | translate}}
      </button>
    </mat-grid-tile>



  </mat-grid-list>
  <br />
  <br />

  <mat-grid-list cols="4" rowHeight="50px">
    <mat-grid-tile>
      <mat-label>تفعيل QR</mat-label>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-slide-toggle (change)="EnableQr($event)" [color]="color" [checked]="enableQr">
      </mat-slide-toggle>
    </mat-grid-tile>

  </mat-grid-list>

  <mat-card>تحديث بيانات بايتك</mat-card>
  <br />
  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="updatePyticCategory()">
        <mat-icon>save</mat-icon>
        {{'updatePyticCategory' | translate}}
      </button>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="updatePyticSubCategory()">
        <mat-icon>save</mat-icon>
        {{'updatePyticSubCategory' | translate}}
      </button>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="updatePyticProduct()">
        <mat-icon>save</mat-icon>
        {{'updatePyticProducts' | translate}}
      </button>
    </mat-grid-tile>


  </mat-grid-list>

  <mat-card>تحديث بيانات اي فواتيركم</mat-card>
  <br />
  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="updateEfwateercome()">
        <mat-icon>save</mat-icon>
        {{'updateEfwateercome' | translate}}
      </button>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-card> نسخ البيانات </mat-card>
  <br />
  <mat-grid-list cols="4" rowHeight="50px">

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="balanceDownload()">
        <mat-icon>cloud_download</mat-icon>
        الارصدة
      </button>
    </mat-grid-tile>

    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="productCardsDownload()">
        <mat-icon>cloud_download</mat-icon>
        البطاقات الغير مباعه
      </button>
    </mat-grid-tile>

  </mat-grid-list>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>